import React, { useEffect, useState } from "react";
import { CardHeader, Col, Row } from "reactstrap";
import { Modal, ModalHeader, ModalBody, Card } from "reactstrap";
import HouseHoldModal from "./HouseHoldModal";
import "./prospectingDetailsPage.scss";
import { catchError } from "../../utils/Utils";
import Service from "../../services";
import { AxiosError, AxiosResponse } from "axios";
import {ReactComponent as Close} from '../../images/Close.svg'

function HouseHoldInfo(props: any) {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [houseHoldInfo, setHouseHoldInfo] = useState<any>([]);

  const service = new Service();
  const handleModal = () => {
    setOpenModal(!openModal);
  };
  const getHouseholdInfo = () => {
    const data = {
      screen: "ProspectDetails",
      sections: "getHouseholdInfo",
      clientId: props?.clientId,
    };
    service
      .getHouseholdInfo(data)
      .then((response: AxiosResponse<any>) => {
        setHouseHoldInfo(response.data);
      })
      .catch((error: AxiosError) => {
        // toast.error("Something Went Wrong");
        catchError(error, true);
      });
  };

  useEffect(() => {
    getHouseholdInfo();
  }, []);

  return (
    <>      
      <Card>
        <CardHeader className="hoseHold-infoHeader"> HOUSEHOLD INFO</CardHeader>
        <Row className="hoseHold-info-labels">
          <Col md={4}>Members of Household</Col>
          <Col md={3}>Relationship</Col>
          <Col>Age</Col>
          <Col>Accts</Col>
          <Col className="full-info" >
            Full Info
          </Col>
        </Row>
        <>
          {houseHoldInfo && houseHoldInfo?.map((row: any) => (
            <Row className="hoseHold-info">
              <Col md={4}>{row.name}</Col>
              <Col md={3}>{row.realtionship}</Col>
              <Col>{row.age}</Col>
              <Col>{row.acts}</Col>
              <Col onClick={handleModal}>
               <span className="view">View</span> 
              </Col>
            </Row>
          ))}
        </>
      </Card>
      <div>
        <Modal
          isOpen={openModal}
          fade={false}
          toggle={handleModal}
          className="view-modal"
          centered
        >
          <Close onClick={handleModal} className='close-icon'   title=""/>
          {/* <ModalHeader toggle={handleModal} >
       
          </ModalHeader> */}
          <ModalBody>
            <HouseHoldModal data={props.data} />
          </ModalBody>
        </Modal>
      </div>
    </>
  );
}

export default HouseHoldInfo;
